var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-link',_vm._b({class:_vm.customClasses,attrs:{"exact-active-class":"active","active-class":"active"}},'b-link',_vm.$props,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }